/**
 * OffertZuordnenDialog — assign (or re-assign) one offer to a submission (P2 Placement Slice 10).
 * The current submission is preselected on a re-assign; a hint explains the new-version semantics.
 */

import { useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';
import type { OfferEintrag, OfferSubmissionGruppe } from '@brokly/shared';

export function OffertZuordnenDialog({
  open,
  onClose,
  item,
  gruppen,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  item: OfferEintrag | null;
  gruppen: OfferSubmissionGruppe[];
  onConfirm: (submissionId: string) => void;
}) {
  const zuordenbar = gruppen.filter((g) => g.submission_id !== null && g.zuordenbar);
  const [submissionId, setSubmissionId] = useState<string>(item?.submission_id ?? '');

  if (!item) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Offerte zuordnen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={!submissionId} onClick={() => onConfirm(submissionId)} data-testid="offert-zuordnen-submit">
            Zuordnen
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-3" data-testid="offert-zuordnen-dialog">
        <label className="flex flex-col gap-1 text-sm">
          <span className="text-muted-foreground">Versicherer</span>
          <select
            className="rounded-md border border-border bg-background p-2 text-sm"
            value={submissionId}
            onChange={(e) => setSubmissionId(e.target.value)}
            data-testid="offert-zuordnen-select"
          >
            <option value="">- bitte waehlen -</option>
            {zuordenbar.map((g) => (
              <option key={g.submission_id!} value={g.submission_id!}>
                {(g.name ?? g.carrier_uid) + ' (' + g.submission_number + ')'}
              </option>
            ))}
          </select>
        </label>
        <p className="text-xs text-muted-foreground">Die Offerte wird als neue Version dieses Versicherers gefuehrt.</p>
      </div>
    </Dialog>
  );
}
